//export const GEOSERVER_URL = 'http://localhost:8080/geoserver/geolinq/ows';
//export const GEOSERVER_URL = 'https://geo.sevenn.be/geolinq/ows';
export const API_URL = 'https://gis.sevenn.be/api/';
export const GEOSERVER_URL = 'https://geo.sevenn.be/geolinq/ows';
//export const API_URL = '/api/';
//export const ADDRESS_LAYER = 'geolinq:nl_full_address';
export const countryConfig = {
  NL: {
    layer: 'geolinq:nl_full_address',
    columns: {
      postcode: 'u104723postcode6_BAG', //'u107260postcode',
      houseNumber: 'u107260huisnummer',
      street: 'u107260straatnaam'
    }
  },
  BE: {
    // Nieuwe GeoServer-set sinds 15 okt 2026 (Veera). Let op: 'huisnunmmer'
    // is de echte kolomnaam in die tabel, met de tikfout.
    layer: 'geolinq:be_full_address',
    columns: {
      postcode: '4pp',
      houseNumber: 'huisnunmmer',
      street: 'straatnaam'
    }
  }
};
